<template>
  <div v-if="isVisible" class="fixed inset-0 bg-gray-600 bg-opacity-70 z-50 flex justify-center items-center p-4">
    <div class="bg-white dark:bg-gray-800 p-6 rounded-lg w-full max-w-md">
      <h2 class="text-lg font-semibold dark:text-gray-100 mb-4">
        Reopen Ticket: #{{ sourceTicketId }}
      </h2>

      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Reopen Date</label>
        <input
          type="datetime-local"
          v-model="day"
          step="1"
          class="w-full p-2 rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-500 dark:border-gray-600 dark:text-gray-100"
        />
      </div>

      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Reopen Note</label>
        <textarea
          v-model="note"
          rows="3"
          class="w-full p-2 rounded-md border-gray-300 shadow-sm dark:bg-gray-500 dark:border-gray-600 dark:text-gray-100"
        ></textarea>
      </div>

      <div class="flex justify-end space-x-2 mt-4">
        <button @click="closeModal" class="bg-gray-400 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded dark:bg-red-500 dark:hover:bg-red-700">
          Cancel
        </button>
        <button @click="save" class="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded dark:bg-yellow-500 dark:hover:bg-yellow-700">
          Reopen Ticket
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReopenTicketModal',
  props: {
    isVisible: { type: Boolean, required: true },
    sourceTicketId: { type: Number, required: true },
    lastActivity: { type: [Date, String], required: false }
  },
  data() {
    const d = this.lastActivity ? new Date(this.lastActivity) : new Date();
    return {
      day: this.formatForDatetimeLocal(d),
      note: ''
    };
  },
  watch: {
    isVisible(nv) {
      if (nv) {
        const d = this.lastActivity ? new Date(this.lastActivity) : new Date();
        this.day = this.formatForDatetimeLocal(d);
        this.note = '';
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    formatForDatetimeLocal(d) {
      if (!(d instanceof Date) || isNaN(d.getTime())) d = new Date();
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const mi = String(d.getMinutes()).padStart(2, '0');
      const ss = String(d.getSeconds()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
    },
    save() {
      if (!this.note) {
        alert('Please enter a note explaining the reopen.');
        return;
      }
      this.$emit('complete', {
        ticketId: this.sourceTicketId,
        day: this.day,
        note: this.note
      });
    }
  }
};
</script>
  